import * as React from "react"

const SvgCheckSquareEmpty = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 21q-.824 0-1.413-.587A1.93 1.93 0 0 1 3 19V5q0-.824.587-1.413A1.93 1.93 0 0 1 5 3h14q.824 0 1.413.587.586.589.587 1.413v14q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21zm0-2h14V5H5z" />
  </svg>
)
export default SvgCheckSquareEmpty
